import { AxiosInstance } from 'axios';
import {
  BusinessPlanDownloadUrl,
  BusinessPlanSurvey,
  BusinessPlanSurveySectionGuidanceKey,
} from './types';

export type BusinessPlanSurveySectionDto = {
  key: BusinessPlanSurveySectionGuidanceKey;
  section: string;
  subsection: string;
  value: string;
};

export type BusinessPlanSurveyDto = {
  sections: Array<BusinessPlanSurveySectionDto>;
  version: number | null;
};

export type BusinessPlanDownloadUrlDto = {
  url: string | null;
  expiration: string | null;
};

export type BusinessPlanApi = ReturnType<typeof getBusinessPlanApi>;

const toBusinessPlanSurvey = (businessPlanSurveyDto: BusinessPlanSurveyDto): BusinessPlanSurvey => {
  return businessPlanSurveyDto;
};

const toBusinessPlanSurveyDto = (businessPlanSurvey: BusinessPlanSurvey): BusinessPlanSurveyDto => {
  return { sections: businessPlanSurvey.sections, version: businessPlanSurvey.version };
};

export const getBusinessPlanApi = (axiosInstance: AxiosInstance) => {
  const getBusinessPlanSurvey = async (): Promise<BusinessPlanSurvey> => {
    const businessPlanSurveyDto = await axiosInstance
      .get<BusinessPlanSurveyDto>(`/business-plan/survey`)
      .then((r) => r.data);
    return toBusinessPlanSurvey(businessPlanSurveyDto);
  };

  const updateBusinessPlanSurvey = async (
    businessPlanSurvey: BusinessPlanSurvey
  ): Promise<BusinessPlanSurvey> => {
    const businessPlanDto = await axiosInstance
      .post<BusinessPlanSurveyDto>(
        `/business-plan/survey`,
        toBusinessPlanSurveyDto(businessPlanSurvey)
      )
      .then((r) => r.data);
    return toBusinessPlanSurvey(businessPlanDto);
  };

  const getBusinessDownloadUrl = async (): Promise<BusinessPlanDownloadUrl> => {
    const businessPlanSurveyDto = await axiosInstance
      .get<BusinessPlanDownloadUrlDto>(`/business-plan/downloadUrl`)
      .then((r) => r.data);
    return {
      url: businessPlanSurveyDto.url,
      expiration: businessPlanSurveyDto.expiration,
    };
  };

  const requestFinancialPartTemplate = async (): Promise<void> =>
    axiosInstance.post('/business-plan/financial-part/template/request');

  return {
    getBusinessPlanSurvey,
    updateBusinessPlanSurvey,
    getBusinessDownloadUrl,
    requestFinancialPartTemplate,
  };
};
